import { Injectable } from '@angular/core';
import { ThemingService } from '@fundamental-ngx/core';
import { Theme } from '../../../../core/helpers/Const';
import { BehaviorSubject } from 'rxjs';
import { ThemeSubjectModel } from './theme-subject.model';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    readonly LOCALSTORAGE_KEY = 'selectedTheme';
    readonly DEFAULT_THEME = Theme.ATOM_DARK;

    selectedTheme = this._localStorageService.get(this.LOCALSTORAGE_KEY) || this.DEFAULT_THEME;
    themeSubject: BehaviorSubject<ThemeSubjectModel>;

    constructor(private _themesService: ThemingService, private _localStorageService: LocalStorageService) {
        this._themesService.setTheme(this.selectedTheme);
        this.themeSubject = new BehaviorSubject<ThemeSubjectModel>(this.createThemeSubject(this.selectedTheme));
    }

    setTheme(theme: string) {
        this._localStorageService.set(this.LOCALSTORAGE_KEY, theme);
        this._themesService.setTheme(theme);
        this.themeSubject.next(this.createThemeSubject(theme));
    }

    createThemeSubject(theme: string): ThemeSubjectModel {
        return {
            selectedTheme: theme,
        };
    }
}
